import React from "react";

// Ce contexte permet de rendre disponible des selects partout dans la hierarchie de composant.
// Usage: <SelectsContext.Provider value={{ SelectType: [...], ... }} >
const SelectsContext = React.createContext({});

export default SelectsContext;
